import React, { useState } from "react";
import IMPSRouting from "./ImpsRouting";
import PgRouting from "./PgRouting";
import UpiRouting from "./UpiRouting";
import CcbpRouting from "./CcbpRouting";
// import PpiRouting from "./PpiRouting";

const MainRouting = () => {
  const [activeTab, setActiveTab] = useState("IMPS");

  const tabs = [
    { name: "IMPS" },
    { name: "UPI" },
    { name: "PG" },
    { name: "CCBP" },
    // { name: "PPI" },
  ];

  const renderComponent = () => {
    switch (activeTab) {
      case "IMPS":
        return <IMPSRouting />;
      case "UPI":
        return <UpiRouting />;
      // case "PPI":
        // return <PpiRouting />;
      case "PG":
        return <PgRouting />;
      case "CCBP":
        return <CcbpRouting />;
      default:
        return null;
    }
  };

  return (
    <div className="p-4">
      {/* Top Buttons */}
      <div className="flex gap-3 mb-6 flex-wrap">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => setActiveTab(tab.name)}
            className={`px-5 py-2 rounded-xl font-medium transition-all duration-200
              ${
                activeTab === tab.name
                  ? "bg-blue-600 text-white shadow-md"
                  : "bg-gray-100 text-gray-700 hover:bg-blue-100"
              }
            `}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {/* Component Render */}
      <div className="bg-white rounded-2xl shadow-md min-h-[300px]">
        {renderComponent()}
      </div>
    </div>
  );
};

export default MainRouting;